import React from 'react';

export default function KPIStrip({ kpis = [] }) {
  const defaultKpis = [
    {
      label: 'Live on site',
      value: '18',
      delta: '↑ 2 this month',
      trend: 'up'
    },
    {
      label: 'In review',
      value: '3',
      delta: 'awaiting partner sign-off',
      trend: null
    },
    {
      label: 'Page views · 30d',
      value: '14.2k',
      delta: '↑ 22.4%',
      trend: 'up'
    },
    {
      label: 'Enquiries attributed',
      value: '14',
      delta: '↓ 3 vs. prior',
      trend: 'down'
    }
  ];

  const displayKpis = kpis.length > 0 ? kpis : defaultKpis;

  return (
    <div className="kpi-strip">
      {displayKpis.map((kpi, idx) => (
        <div key={idx} className="kpi">
          <span className="kpi__label">{kpi.label}</span>
          <span className="kpi__value">{kpi.value}</span>
          <span className={`kpi__delta ${kpi.trend ? `kpi__delta--${kpi.trend}` : ''}`}>
            {kpi.delta}
          </span>
        </div>
      ))}
    </div>
  );
}
